/**
 * The page header bar, shared by every page so the headers cannot drift apart
 * again: 60px tall including its bottom border, 16px from the sidebar edge,
 * the title in Inter 14px medium (#0a0a0a in light mode), everything centred
 * on the bar. Measured off the design prototype's Knowledge Graph and Tag
 * Mapping headers.
 *
 * `subpixel-antialiased` gives the header's text macOS's default font
 * smoothing back. The app body sets `antialiased`, which turns off the stem
 * thickening the design renders with, so a 500-weight title read lighter than
 * the design's (the design's ink sits between our 500 and 600, while its width
 * is exactly 500's). It applies to every header's text, breadcrumbs included.
 *
 * Layout extras (justify-between, gap-3) stay with each page:
 * `${PAGE_HEADER} justify-between`.
 */
export const PAGE_HEADER =
  'flex h-[60px] shrink-0 items-center border-b border-border bg-background px-4 subpixel-antialiased dark:bg-dark-card'

/** The page title inside PAGE_HEADER. */
export const PAGE_TITLE = 'text-sm font-medium text-foreground'
